export enum EDiscountType {
  COMMON = 'COMMON',
  VOUCHER = 'VOUCHER'
}
export interface ISummary {
  totalPrice: number
  totalDiscount: number
  net: number
}
